module.exports = {
  H4: 'Valor de crédito devolvido pelo banco do recebedor',
  AM: 'Valor de crédito devolvido pelo banco do recebedor',
  H3: 'Valor de crédito devolvido pelo banco do recebedor',
  Z1: 'Conta corrente ou de poupança do recebedor com bloqueio',
  AN: 'Conta ou dígito verificador da conta inválido',
  ZA: 'Conta corrente ou de poupança do recebedor com bloqueio',
  AL: 'Valor de crédito devolvido pelo banco do recebedor',
  RJ: 'Valor de crédito devolvido pelo banco do recebedor',
  AE: 'CPF/CNPJ informado diverge do CPF/CNPJ no banco',
  AT: 'CPF/CNPJ informado diverge do CPF/CNPJ no banco',
  CD: 'CPF/CNPJ informado diverge do CPF/CNPJ no banco',
  AJ: 'Valor de crédito devolvido pelo banco do recebedor',
  AG: 'Agência ou dígito verificador da agência inválido',
  Z7: 'Agência ou conta destinatária do crédito inválida',
  CN: 'Conta não cadastrada',
  AA: 'Controle inválido',
  Z0: 'Conta com bloqueio',
  DV: 'DOC / TED Devolvido pelo banco do recebedor',
  BH: 'Conta do recebedor sem limite para crédito'
};
